/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import Login from './Login';
import { screenNav } from '../state/states';

export default function Landing({ mobile }) {
    return (
        <>
            <Login mobile={mobile} />
            <div className="fixed bottom-4 left-2 z-50 flex gap-4 px-4 py-2 text-sm">
                <button
                    onClick={() => screenNav.set('gdpr')}
                    className="m-0 border-none bg-transparent p-0 text-gray-600 text-inherit hover:cursor-pointer hover:underline"
                >
                    Datenschutzerklärung
                </button>
                <button
                    onClick={() => screenNav.set('imprint')}
                    className="m-0 border-none bg-transparent p-0 text-gray-600 text-inherit hover:cursor-pointer hover:underline"
                >
                    Impressum
                </button>
            </div>
        </>
    );
}
